
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { CachedDataService } from '@services/data/cached-data.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private cachedDataService: CachedDataService) {
  }

  public canActivate() {
    if (this.cachedDataService.isAuth()) {
      if (this.cachedDataService.getCurrentUser() && this.cachedDataService.getCurrentUser().phoneNumberConfirmed) {
        this.router.navigate(['/online']);
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}






// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts